import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { TransactionDetailResponse } from '@/repositories/generated';

const response: TransactionDetailResponse = {
  campaignList: {
    campaignInfo: [
      {
        amount: 1000,
        balanceType: 'BONUS_POINT',
        campaignId: '40230323090000123123',
        campaignName: '202203_感謝祭10%',
        grantDateTime: '2023-04-23T00:00:00+09:00',
        grantStatus: 'GRANTED',
        transactionId: undefined,
      },
    ],
  },
  cancelFlg: true,
  creditCardInfo: {
    amount: 1000,
    feeCategory: '00',
    numberPayments: 0,
    paymentCategory: '10',
    paymentMethodId: 25,
  },
  directBankInfo: {
    amount: 1000,
    bankName: '三菱UFJ銀行',
    merchantId: 'BMRS000044',
    merchantTransactionId: '0000000000001202308085060',
    paymentMethodId: 25,
    walletServiceId: '001',
  },
  errorCode: '10xxxxxxxx',
  errorMessage: 'テキストテキストテキストテキスト',
  giftInfo: {
    giftDetailInfo: [
      {
        amount: 7000,
        giftDetailName: '【赤券】（大型店・一般店で利用可能）',
      },
    ],
    giftName: 'プレミアム付商品券',
    premiumRate: 0.3,
    purchaseCode: '1234567890123456',
    purchaseCount: 2,
  },
  prepaidInfo: {
    balanceReason: '追加返金のため',
    basicPoint: 1000,
    bonusPoint: 1000,
    bonusValue: 1000,
    bulkGrantId: '12345678',
    bulkGrantName: '2309_ログイン特典',
    expiredReason: '期限切れ',
    fundsTransferValue: 1000,
    giftDetailName: '【赤券】（大型店・一般店で利用可能）',
    grantStatus: 'GRANTED',
    paymentMethodId: 25,
    prepaidValue: 1000,
    usedGiftName: 'プレミアム付商品券',
    physicalCardNumber: '0000000000000001',
  },
  status: 'SUCCESS',
  transactionAmount: 1000,
  transactionBasicInfo: {
    walletServiceId: '001',
    walletServiceName: '〇〇Pay',
    accountId: '9',
    acquirerId: 1,
    acquirerName: 'テストアクワイアラ１',
    codeType: 'CPM',
    companyId: '00001',
    companyName: '株式会社○○',
    externalAcquirerId: 'Acquirer_1',
    externalCompanyId: 'company_00001',
    externalShopId: 'shop_00000001',
    externalTerminalId: 'terminal10021',
    externalUserId: '456',
    issuerId: '1',
    issuerName: 'テストイシュア１',
    receiptId: '123456789',
    shopId: '00000001',
    shopName: '○○○○渋谷店',
    shopPhone: '090-1111-2222',
    terminalId: '0000000100001',
    transactionDateTime: '2023-04-23T00:00:00+09:00',
    walletUserId: '17',
  },
  transactionCancelInfo: {
    canceledReceiptId: '123456789',
    canceledTransactionDateTime: '2023-04-23T00:00:00+09:00',
    canceledTransactionId: '00220329182752560008',
  },
  transactionId: '00220329182752560003',
  transactionType: 'PREPAID_SETTLEMENT',
};

export const transactionDetail = http.get(
  createMockEndpoint('/transaction/:id'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
